import { createContext } from 'react';

export interface AuthContextValue {
  /** Opens the auth modal. Resolves `true` after ANY successful path
   *  (register / sign-in / reset-confirm / attach), `false` on close. */
  requestAuth: () => Promise<boolean>;
  /** Operator runs `registration_mode: required`. */
  registrationRequired: boolean;
  /** The current session's user already has a registration profile. */
  registered: boolean;
  /** Flips `registered` locally after a successful attach — no refetch. */
  markRegistered: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
